import React, { useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
// import "./styles.css";
import styled, { css } from "styled-components";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  FormFooter,
  ContentBlock,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";

import PAh2 from "./PAh2";

export const PAmodal = ({
  size = "md",
  appearance = "primary", //flatten
  indentation = "md",
  children,
  extra,
  header,
  handleModal = ()=>void(0),
  handleConnect,
  submitActive = false,
  footer = true,
  closeButton = true,
}) => {

  const [state, setState] = useState(false);
  const [stateD, setDState] = useState(true);
  useEffect(() => {
    setState(true);
    setTimeout(() => {
      setDState(false);
    }, 400);
    return () => {};
  }, []);


  if (size === 'xlg') {
    return (

      <React.Fragment>
      <div className="xsui-modal xsui-modal--size-lg">
        <div className="xsui-modal__overlay" />

        <div
          className="xsui-modal__entry"
          style={{
            width: "100%",
            macWidth: "100%",
            // height: '99%',
            position: "absolute",
            left: "0px",
            right: "0px",
            top: "16px",
            bottom: "16px"
          }}
          // onClick={e => {
          //   e.preventDefault();
          //   handleModal();
          // }}
        >
          <CSScloseModal
            className="xsui-modal__close"
            data-id="close_modal"
            onClick={e => {
              handleModal();
            }}
            style={{
              position: "absolute",
              width: "auto",
              left: "50%",
              minWidth: "60px",
              right: "44px",
              top: "16px",
              zIndex: 1000,
              marginLeft: 647,
              opacity: 0
            }}
          />

          <div
            className="xsui-content-block xsui-content-block--appearance-modal"
            style={{
              width: "100%",
              height: "100%",
              maxWidth: "98%",
              padding: 0,
              overflow: "hidden"
            }}
          >
            {stateD && (
              <div
                className="sb0_z"
                style={{
                  transition: "opacity 800ms ease-in",
                  opacity: state ? 0 : 1
                }}
              >
                <div className="sb0_z_preloader sb0_z_preloader--svg" />
                <div className="sb0_z_preloader" />
              </div>
            )}

            {children}

          </div>
        </div>
      </div>
    </React.Fragment>
    )
  } else { return (
<div>
      <div className={`${size === 'md' ? 'xsui-modal xsui-modal--size-md' :
        size === 'lg' ? 'xsui-modal xsui-modal--size-lg' :
        size === 'sm' ? 'xsui-modal xsui-modal--size-sm' :
        'xsui-modal xsui-modal--size-md'
      }`}
    >
        <div className="xsui-modal__overlay" onClick={() => handleModal()} />

        <div className="xsui-modal__entry">
          <div
            className={appearance === 'flatten' ? "" : "xsui-content-block xsui-content-block--appearance-modal"}
            style = {{
              padding: indentation === 'md' ? '24px 32px' : '0'
            }}
          >
            {closeButton && <div
              style={{
                position: "absolute",
                top: 24,
                left: "100%",
                width: 54,
                height: 54,
                backgroundColor: "rgba(0,0,0,.5)",
                backgroundImage:
                  "url(//cdn.xsolla.net/publisher-v4/close.adbd79.svg)",
                backgroundPosition: "50%",
                backgroundRepeat: "no-repeat",
                cursor: "pointer",
                transition: "background-color .1s ease-in-out"
              }}
              data-id="close_modal"
              onClick={() => handleModal()}
            />}

            {!!header && <FormGroup indentation="xs">
            <PAh2 tag='h2' title={header}>{extra}</PAh2>
            </FormGroup>}

            <FormGroup indentation="xs">
              {children}
            </FormGroup>

            {!!footer && footer}

            {/* {!!footer && <FormFooter>
              <Button
                appearance="outline"
                onClick={() => {
                  handleModal();
                }}
              >
                Discard
              </Button>
              <Button
                appearance="primary"
                disabled = {submitActive ? false : true}
                onClick={() => {
                  handleModal();
                  handleConnect();
                }}
              >
                Connect
              </Button>
            </FormFooter>} */}
          </div>
        </div>
</div>
</div>


  )}
};



export default PAmodal;


export const CSScloseModal = styled.div`
  @media (max-width: 768px) {
    position: absolute;
    top:8px;
    right: 8px;
  }
`




// const Body = () => {
//   let [state, setState] = useState({
//     opened: false
//   });

//   const handleModal = () => {
//     setState({
//       opened: false
//     });
//   };

//   return (
//     <div className="App">
//       <Button
//         onClick={() => {
//           setState({
//             opened: true
//           });
//         }}
//       >
//         Open Pop
//       </Button>
//       <FormGroup>
//         {state.opened && <PAmodal handleModal={handleModal} />}
//       </FormGroup>
//     </div>
//   );
// };

// const rootElement = document.getElementById("root");
// ReactDOM.render(<Body />, rootElement);
